<template>
    <div class="global-search">
        <section class="top-wrapper">
            <p class="back" @click="goBackCommunity">
                <img height="28px" width="28px" src="../../images/community/arrows-left.png" alt="">
                <span>搜索结果</span>
            </p>
            <div class="center-content">
                <search-select
                    class="global-search-select"
                    placeholder="请输入关键字或选择标签"
                    :searchSelectValue="searchSelectValue"
                    @onClearSelectTag="onClearSelectTag"
                    @change="handleSearchSelectChange"
                    @clear="handleClearSearchSelect">
                </search-select>
                <ul class="topic-tabs">
                    <li
                        :class="['tabs__item', { 'is-active': curTypeTab === item.id }]"
                        v-for="item in topicTypeList"
                        :key="item.id"
                        @click="onTopicTypeToggle(item.id)">
                        <span>{{ item.label }}</span>
                        <span>（</span>
                        <span>{{ item.count }}</span>
                        <span>）</span>
                    </li>
                    <li class="tabs-bar" :style="{'transform': `translateX(${ tabIndex * 120 }px)`}"></li>
                </ul>
            </div>
        </section>
        <section class="bottom-wrapper" v-loading="isProductLoading">
            <div class="best-area" >
                <!-- 问答专区/经验文章 展示最新tab栏 -->
                <div class="best-list">
                    <span
                        :class="['best-item', {'active': item.type === curBestTab}]"
                        v-for="item in bestList"
                        :key="item.id"
                        @click="curBestTab = item.type">
                        {{item.title}}
                    </span>
                </div>
                <p :class="['label-filter', { 'active': isShowLabelFilter }]" @click="isShowLabelFilter = !isShowLabelFilter">
                    <span>标签筛选</span>
                    <img src="../../images/community/hover-angle-up.png" alt="">
                </p>
            </div>
            <!-- 问答专区/经验文章 展示热门标签   社区活动展示活动状态/类型 -->
            <div class="label-area" v-if="isShowLabelFilter">
                <label class="label-title">热门标签：</label>
                <div class="label-list">
                    <li
                        v-for="item in hotTagsList"
                        :key="item.title"
                        :class="['label-item', {'active': selectedTagList.includes(item.title)}]">
                        <span slot="reference" @click="onSelectTag(item)">
                            {{ item.title }}
                        </span>
                    </li>
                </div>
            </div>
            <ul class="topic-list" v-if="topicList.length">
                <li :class="`data-item data-item${item.id}`" v-for="(item,index) in topicList" :key="index">
                    <topicContainer
                        v-if="item.board === 'qa'"
                        :topicInfo="item"
                        :fixedCommentId="fixedCommentId"
                        :isSearch="true"
                        :isLogin="isLogin"
                        @tagSelector="onSelectCommentTag"
                        @onApproval="onApproval"
                        @onShowAllComment="onShowAllComment"
                        @focusToggle="focusToggle">
                    </topicContainer>
                    <articleContainer
                        v-else
                        :articleInfo="item"
                        :isSearch="true"
                        :isLogin="isLogin"
                        @tagSelector="onSelectCommentTag"
                        @onVoteToggle="onVoteToggle"
                        @favoriteToggle="favoriteToggle">
                    </articleContainer>
                </li>
            </ul>
            <div class="search-null" v-else-if="!isProductLoading">
                <img src="../../images/developer/null.png" alt="" />
                <p>未搜索到相关的内容</p>
            </div>
            <div class="load-more" v-show="topicList.length">
                <img v-if="isLoading" alt="loading" src="../../images/common/loading_2_24x24.gif">
                <p class="no-more" v-else-if="topicList.length === listCount">没有更多问答了</p>
                <p v-else @click="doLoadMore()">加载更多</p>
            </div>
        </section>
        <goBack></goBack>
    </div>
</template>

<script>
    import searchSelect from '../common/searchSelect.vue'
    import mavonEditor from 'mavon-editor'
    import topicContainer from './topicContainer.vue'
    import articleContainer from './articleContainer.vue'
    import goBack from '../common/goback.vue'
    import tools from '@/js/tools.js'
    export default {
        components: {
            searchSelect,
            topicContainer,
            articleContainer,
            goBack
        },
        data() {
            const { searchText, curBestTab, curTypeTab, selectTag, nickName } = this.getInitialSearchCondition()
            const initBestList = [
                {
                    title: '最新',
                    type: 'latest',
                    id: 1
                }, {
                    title: '最热',
                    type: 'hottest',
                    id: 2
                }, {
                    title: '待答',
                    type: 'unanswer',
                    id: 4
                }
            ]
            return {
                searchSelectValue: [],
                topicTypeList: [
                    {
                       id: 'all',
                       label: '全部',
                       count: 0 
                    }, {
                       id: 'qa',
                       label: '问答',
                       count: 0
                    }, {
                       id: 'article',
                       label: '文章',
                       count: 0 
                    }
                ],
                topicObj: {
                    all: [],
                    qa: [],
                    article: []
                },
                searchText: searchText || '',
                nickName: nickName || '',
                curTypeTab: curTypeTab || '',
                curBestTab: curBestTab || 'latest',
                selectedTagList: selectTag || [],
                initBestList,
                bestList: initBestList,
                isShowLabelFilter: true,
                hotTagsList: [],
                expandedComments: [], // 评论展开id列表
                fixedCommentId: '', // 当定固定的评论id
                original: false,
                isLoading: false,
                totalPage: 0,
                page: {
                    limit: 10,
                    curPage: 1
                },
                isPageOver: false,
                isThrottled: false,
                pollingTimer: null,
                isProductLoading: false,
                topicList: []
            }
        },
        computed: {
            isLogin () {
                return this.$store.state.isLogin
            },
            listCount () {
                const curTypeTabInfo = this.topicTypeList.find(item => item.id === this.curTypeTab)
                return curTypeTabInfo.count || 0
            },
            tabIndex () {
                const index = this.topicTypeList.findIndex(item => item.id === this.curTypeTab)
                return index > -1 ? index : 0
            }
        },
        watch: {
            curBestTab (val) {
                this.isProductLoading = true
                this.getQuestionList()
            }
        },
        async created () {
            this.original = false
            // 根据url上面的selectedTagList和searchText生成搜索框内容
            if (this.selectedTagList.length) {
                this.selectedTagList.forEach(item => {
                    this.setSearchSelectValue('tag', item)
                })
            }
            if (this.searchText) {
                this.searchText.split(',').forEach(item => {
                    this.setSearchSelectValue('text', item)
                })
            }
            if (this.nickName) {
                this.nickName.split(',').forEach(item => {
                    this.setSearchSelectValue('name', item)
                })
            }
            this.getTags()
            this.isProductLoading = true
            await this.getQuestionList(false, this.curTypeTab)
            this.isProductLoading = false
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 获取url中带的参数状态
            getInitialSearchCondition () {
                let { searchText, curBestTab = 'latest', curTypeTab = 'all', selectTag, nickName } = this.$route.query
                if (this.$route.params.setSearchKey) {
                    searchText = this.$route.params.setSearchKey
                }
                searchText = searchText ? decodeURIComponent(searchText) : ''
                if (selectTag) {
                    selectTag = decodeURIComponent(selectTag).split(',')
                }
                return { searchText, curBestTab, curTypeTab, selectTag, nickName }
            },
            setSearchSelectValue (id, val, isAllowDelete) {
                const index = this.searchSelectValue.findIndex(item => item.id === id)
                if (index > -1) {
                    const selectContent = this.searchSelectValue[index]
                    const valIndex = selectContent.values.findIndex(item => item === val)
                    if (valIndex > -1 && isAllowDelete) {
                        selectContent.values.splice(valIndex, 1)
                        if (!selectContent.values.length) {
                            this.searchSelectValue.splice(index, 1)
                        }
                    }
                    if (valIndex === -1) {
                        selectContent.values.push(val)
                    }
                } else {
                    const name = id === 'tag' ? '标签' : id === 'text' ? '关键字' : '用户'
                    this.searchSelectValue.push({
                        id,
                        name,
                        isSelect: false,
                        values: [val]
                    })
                }
            },
            // 获取tab对应的匹配的个数
            getSearchCount (params) {
                try {
                    axios.get(myUrl + `forum/topics/search_count/`, { params }).then((res) => {
                        const resp = res.data.data
                        this.topicTypeList.forEach(item => {
                            const id = item.id === 'all' ? 'total' : item.id
                            item.count = resp[id] || 0
                        })
                        console.log(res);
                    })
                } catch (error) {
                    console.warn(error);
                }
            },
            // 获取标签
            getTags () {
                try {
                    axios.get(myUrl + `forum/tag/`).then((res) => {
                        if (res.data.result) {
                            this.hotTagsList = res.data.data.results
                        }
                    })
                } catch (error) {
                    console.warn(error)
                }
            },
            // 选中评论标签
            onSelectCommentTag (info) {
                const title = info.title
                const index = this.searchSelectValue.findIndex(item => item.id === 'tag')
                const selectContent = this.searchSelectValue[index]
                if (selectContent && selectContent.values.includes(title)) return
                const curTag = this.hotTagsList.find(item => item.title === title)
                if (curTag && !this.selectedTagList.includes(title)) {
                    this.selectedTagList.push(title)
                }
                this.setSearchSelectValue('tag', title)
                this.isProductLoading = true
                this.getQuestionList()
            },
            async getQuestionList (isLoadMore, board = this.curTypeTab) {
                if (!isLoadMore) {
                    $('html,body').animate({
                        scrollTop: 0
                    }, 600)
                }
                // 根据searchSelect生成keyword和tag
                let keyword = undefined
                const searchTextInfo = this.searchSelectValue.find(item => item.id === 'text')
                if (searchTextInfo) {
                    keyword = searchTextInfo.values.join(',')
                }
                let tag = undefined
                const selectTagInfo = this.searchSelectValue.find(item => item.id === 'tag')
                if (selectTagInfo) {
                    tag = selectTagInfo.values.join(',')
                }
                let nickName = undefined
                const selectNameInfo = this.searchSelectValue.find(item => item.id === 'name')
                if (selectNameInfo) {
                    nickName = selectNameInfo.values.join(',')
                }
                // 修改路由参数
                if (this.original) {
                    const query = {
                        selectTag: tag ? encodeURIComponent(tag) : undefined,
                        nickName,
                        searchText: keyword ? encodeURIComponent(keyword) : undefined,
                        curTypeTab: board,
                        curBestTab: this.curBestTab
                    }
                    this.$router.push({
                        path: `/s-mart/community/search`,
                        query
                    })
                }
                const params = {
                    page: this.page.curPage,
                    page_size: this.page.limit,
                    board: board !== 'all' ? board : undefined,
                    tag,
                    keyword,
                    nickname: nickName
                }
                const bestTab = this.curBestTab
                params.ordering= bestTab === 'latest'
                    ? '-created_on'
                    : bestTab === 'hottest'
                    ? '-hottest'
                    : bestTab === 'unanswer'
                    ? '-created_on'
                    : '-comment_on'

                const path = bestTab === 'unanswer' ? 'forum/topics/unanswer/' : 'forum/topics/'
                // 获取tab对应的匹配的个数
                if (!isLoadMore) {
                    await this.getSearchCount({ tag, keyword, nickname: nickName })
                }
                await axios.get(myUrl + path, {
                    params
                }).then(res => {
                    const resp = res.data
                    if (!resp.result) return
                    this.isLoading = false // 数据加载出来后去掉按钮的loading效果并且防止重复点击
                    this.totalPage = Math.ceil(resp.data.count / 10)
                    this.isPageOver = this.page.curPage >= this.totalPage
                    if (this.page.curPage === 1) {
                        this.topicList = [] // 切换过滤条件时，清空数组，重新拿到新的数据渲染页面
                    }
                    /*
                     * 这部分的逻辑有两层：
                     *  1.点击“加载更多”按钮进行数据的累加
                     *  2.切换选项卡的时候进行数据的替换
                    */
                    resp.data.results.forEach(element => {
                        // 描述
                        this.$set(element, 'afterhtmlData', '')
                        // 根据keyword筛选后的标题
                        this.$set(element, 'afterHtmlTitle', '')
                        // 根据keyword筛选后的用户名
                        this.$set(element, 'afterHtmlName', '')
                        // 赞同
                        this.$set(element, 'is_approval', false)
                        // 显示的文本
                        this.$set(element, 'descText', '')
                        // 默认显示第一张图片
                        this.$set(element, 'imgSrc', '')
                        // 评论是否需要查看详情
                        this.$set(element, 'isShowAllComment', false)
                        // 评论是否展开详情
                        this.$set(element, 'isAllComment', false)
                        // 评论展示为文章内容
                        this.$set(element, 'isMatchComment', false)

                        if (element.format !== 'Markdown') {
                            element.afterhtmlData = filterXSS(element.description);
                        } else {
                            const data = mavonEditor.markdownIt.render(element.description)
                            const resData = tools.setImgCustomAttr(data)
                            element.afterhtmlData = filterXSS(resData)
                        }
                        element.afterHtmlName = element.created_by.nick_name
                        // 根据关键字筛选
                        const index = this.searchSelectValue.findIndex(item => item.id === 'text')
                        if (index > -1) {
                            const searchText = this.searchSelectValue[index].values[0]
                            // 根据keyword筛选后的标题
                            const titleIndex = element.title.indexOf(searchText)
                            if (titleIndex > -1) {
                                const titleList = element.title.split(searchText)
                                element.afterHtmlTitle = titleList.join(`<span style="color: #e2524c">${searchText}</span>`)
                            }
                            if (!element.no_of_comment) {
                                element.isMatchComment = true
                                element.no_of_comment = 1
                                this.$set(element, 'comment', '')
                            }
                            // 根据keyword筛选匹配的内容
                            this.$nextTick(() => {
                                const dom = document.querySelector(`#virtual-dom-${element.id}`)
                                if (dom) {
                                    const textContent = dom.textContent
                                    const contentIndex = textContent.indexOf(searchText)
                                    if (contentIndex > -1) {
                                        const descList = textContent.split(searchText)
                                        descList[0] = '...'
                                        element.comment = descList.join(`<span style="color: #e2524c">${searchText}</span>`)
                                    } else {
                                        element.comment = textContent.slice(0, 200)
                                    }
                                    if (board === 'article') {
                                        element.descText = element.comment
                                        element.imgSrc = dom.querySelector('img') ? dom.querySelector('img').src : ''
                                    }
                                    element.isMatchComment = true
                                }
                            })
                        }
                        // 根据关键字筛选用户名
                        const nameIndex = this.searchSelectValue.findIndex(item => item.id === 'name')
                        if (nameIndex > -1) {
                            const searchName = this.searchSelectValue[nameIndex].values
                            // 根据keyword筛选后的用户名
                            searchName.forEach(item => {
                                if (element.afterHtmlName.indexOf(item) > -1) {
                                    const nameList = element.afterHtmlName.split(item)
                                    element.afterHtmlName = nameList.join(`<span style="color: #e2524c">${item}</span>`)
                                }
                            })
                        }
                        // 是否赞同
                        if (element.comment_up_list) {
                            const approval = element.comment_up_list.some(comment => comment.user_id === this.userId)
                            element.is_approval = approval
                        }
                        // 文章描述&&和图片
                        if (index === -1 && board === 'article') {
                            this.$nextTick(() => {
                                const dom = document.querySelector(`#virtual-dom-${element.id}`)
                                if (dom) {
                                    element.descText = dom.textContent
                                    element.imgSrc = dom.querySelector('img') ? dom.querySelector('img').src : ''
                                }
                            })
                        }
                        // 问答专区评论是否需要查看详情
                        if  (board === 'qa' && element.comment) {
                            this.$nextTick(() => {
                                this.setCommentShowMore(element)
                            })
                        }
                    })
                    if (!isLoadMore) {
                        this.topicObj[board] = resp.data.results
                    } else {
                        this.topicObj[board].push(...resp.data.results)
                    }
                    this.topicList = this.topicObj[board]
                    this.original = true
                    this.isProductLoading = false
                }).catch (error => {
                    console.warn(error)
                    this.isProductLoading = false
                })
            },
            // 给所有高超过2行/4行的评论设置显示更多
            setCommentShowMore (element) {
                const dataItemDom = document.querySelector(`.data-item${element.id}`)
                const descDom = dataItemDom.querySelector('.desc')
                if (!descDom) return
                const imgDom = dataItemDom.querySelector('.common-img')
                const height = descDom.getBoundingClientRect().height
                element.isShowAllComment = imgDom ? height >= 66 : height > 44
            },
            goBackCommunity () {
                this.$router.push({
                    path: '/s-mart/community/question'
                })
            },
            // 选中标签
            onSelectTag (tag) {
                const index = this.selectedTagList.findIndex(item => item === tag.title)
                if (index > -1) {
                    this.selectedTagList.splice(index, 1)
                } else {
                    this.selectedTagList.push(tag.title)
                }
                this.setSearchSelectValue('tag', tag.title, true)
                this.isProductLoading = true
                this.getQuestionList()
            },
            // 赞同
            onApproval (data) {
                const questionItem = this.topicList.find(item => item.id === data.id)
                if (this.isLogin) {
                    let params = {
                        action: questionItem.is_approval ? 'down' : 'up',
                        parent_id: questionItem.comment_id
                    }
                    axios.post(myUrl + 'forum/usercomment/', qs.stringify(params)).then(res => {
                        const index = questionItem.comment_up_list.findIndex(item => item.user_id === this.userId)
                        if (index > -1) {
                            questionItem.comment_up_list.splice(index, 1)
                        } else {
                            questionItem.comment_up_list.push({ user_id: this.userId })
                        }
                        questionItem.is_approval = !questionItem.is_approval
                    })
                } else {
                    axios.get(myUrl + 'login/test/').then(res => {
                        if (!res.data.result) return
                    })
                }
            },
            // 显示全部评论
            onShowAllComment (id) {
                let isShow = false
                this.topicList.some(item => {
                    if (item.id === id) {
                        item.isAllComment = !item.isAllComment
                        isShow = item.isAllComment
                        return
                    }
                })
                if (!isShow) {
                    const el = document.querySelector(`.data-item${id}`)
                    const height = el.getBoundingClientRect().top
                    const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
                    window.scrollTo({
                        top: height + scrollTop - 130,
                        behavior: "smooth"
                    })
                }
                const index = this.expandedComments.findIndex(item => item === id)
                if (index > -1) {
                    this.expandedComments.splice(index, 1)
                } else {
                    this.expandedComments.push(id)
                }
                // 滚动时根据评论高度来设置吸底效果
                this.$nextTick(() => {
                    this.handleScroll()
                })
            },
            // 关注&取消关注
            focusToggle (item) {
                if (!this.isLogin) {
                    this.onLogin()
                    return
                }
                let params = {
                    topic_id: item.id,
                    is_followed: !item.is_followed
                };
                axios.post(myUrl + 'forum/usertopic/', qs.stringify(params)).then((res) => {
                    if (res.data.result) {
                        item.is_followed = !item.is_followed
                        let msg = ''
                        if (item.is_followed) {
                            item.no_of_followed += 1
                            msg = '关注成功'
                        } else {
                            item.no_of_followed -= 1
                            msg = '取消关注'
                        }
                        this.$message({
                            message: msg,
                            type: 'success'
                        })
                    }
                });
            },
            // 点赞&取消点赞
            onVoteToggle (val) {
                try {
                    if (!this.isLogin) {
                        this.onLogin()
                        return
                    }
                    let params = {
                        topic_id: val.id,
                        vote: val.is_vote_up ? null : true
                    }
                    axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                        if (res.data.result) {
                            val.is_vote_up = val.is_vote_up ? null : true
                            let msg = ''
                            if (val.is_vote_up) {
                                val.no_of_vote_up += 1
                                msg = '点赞成功'
                            } else {
                                val.no_of_vote_up -= 1
                                msg = '取消点赞成功'
                            }
                            this.$message({
                                message: msg,
                                type: 'success'
                            })
                        }
                    })
                } catch (error) {
                    console.warn(error);
                }
            },
            // 收藏&取消收藏
            favoriteToggle (item) {
                if (!this.isLogin) {
                    this.onLogin()
                    return
                }
                let params = {
                    topic_id: item.id,
                    is_like: !item.is_liked
                };
                axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                    if (res.data.result) {
                        item.is_liked = !item.is_liked
                        let msg = ''
                        if (item.is_liked) {
                            item.no_of_likes += 1
                            msg = '收藏成功'
                        } else {
                            item.no_of_likes -= 1
                            msg = '取消收藏成功'
                        }
                        this.$message({
                            message: msg,
                            type: 'success'
                        })
                    }
                })
            },
            onClearSelectTag (id, selectValues) {
                if (id === 'text') {
                    this.searchText = ''
                } else if (selectValues) {
                    this.selectedTagList = this.selectedTagList.filter(val => selectValues.includes(val))
                } else {
                    this.selectedTagList = []
                }
            },
            handleSearchSelectChange (val) {
                this.searchSelectValue = val
                const selectTagInfo = this.searchSelectValue.find(item => item.id === 'tag')
                if (selectTagInfo) {
                    this.selectedTagList = JSON.parse(JSON.stringify(selectTagInfo.values))
                }
                this.page.curPage = 1
                this.isProductLoading = true
                this.getQuestionList()
            },
            handleClearSearchSelect () {
                this.searchText = ''
                this.searchSelectValue = []
                this.selectedTagList = []
                this.page.curPage = 1
                this.isProductLoading = true
                this.getQuestionList()
            },
            onTopicTypeToggle (tabId) {
                this.curTypeTab = tabId
                this.isProductLoading = true
                this.page.curPage = 1
                this.getQuestionList()
            },
            doLoadMore () { // 加载更多
                if (this.isLoading) return
                this.isLoading = true // 加载更多里的loading效果
                this.original = false
                this.page.curPage++
                this.getQuestionList(true)
            },
            // 监听滚动
            handleScroll () {
                // 处理单个问答评论"收起"吸底
                if (this.expandedComments.length) {
                    let fixedId = ''
                    this.expandedComments.some(id => {
                        const el = document.querySelector(`.data-item${id}`)
                        if (el) {
                            const contentEl = el.querySelector('.comment-desc')
                            const { top, bottom, height } = contentEl.getBoundingClientRect()
                            // "收起"栏吸底需要满足条件：
                            // 评论内容高度超过视口高度；评论内容在视口范围内；评论顶部距视口底部距离超过 200 px
                            if (height > window.innerHeight && bottom > window.innerHeight && top < window.innerHeight - 200) {
                                fixedId = id
                                return true
                            }
                        }
                    })
                    this.fixedCommentId = fixedId
                }
                // 滚动加载
                if (!this.isPageOver && !this.isThrottled && !this.isLoading) {
                    this.isThrottled = true
                    this.pollingTimer = setTimeout(() => {
                        this.isThrottled = false
                        const scrollHeight = document.documentElement.scrollHeight
                        const innerHeight = window.innerHeight
                        const scrollY = window.scrollY
                        const height = 80 + 320 // 320 footer的高度
                        if (scrollHeight - innerHeight - scrollY < height) {
                            clearTimeout(this.pollingTimer)
                            this.doLoadMore()
                        }
                    }, 200)
                }
            },
            onLogin () {
                axios.get(myUrl + 'login/test/')
            }
        }
    }
</script>

<style lang="scss">
    .global-search-select {
        position: absolute !important;
        top: 0;
        left: 0;
        width: 700px !important;
        .search-input {
            min-height: 34px !important;
            max-height: 100px !important;
        }
        .search-icon, .close-icon {
            top: 10px !important;
        }
    }
</style>
<style lang="scss" scoped>
    .global-search {
        padding-top: 60px;
        background: #f5f7fa;
        .top-wrapper {
            position: relative;
            height: 156px;
            background: #fff;
            box-shadow: 0px 2px 4px 0px rgba(25,25,41,0.05); 
            margin-bottom: 16px;
            padding-top: 55px;
            font-size: 14px;
            color: #63656e;
            .back {
                position: absolute;
                top: 15px;
                left: 16px;
                display: flex;
                align-items: center;
                font-size: 16px;
                cursor: pointer;
                img {
                    margin-right: 10px;
                }
                &:hover {
                    color: #3a84ff;
                }
            }
            .center-content {
                height: 101px;
                width: 1200px;
                margin: 0 auto;
                position: relative;
                .topic-tabs {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    .tabs-bar {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 120px !important;
                        height: 2px;
                        background: #3a84ff;
                        border-radius: 1px;
                        transition: transform .3s cubic-bezier(.645,.045,.355,1);
                    }
                    .tabs__item {
                        width: 120px !important;
                        color: #63656e;
                        line-height: 40px;
                        text-align: center;
                        padding: 0;
                        cursor: pointer;
                        &.is-active {
                            color: #3a84ff;
                            font-weight: 700;
                        }
                        &:hover {
                            color: #3a84ff;
                        }
                    }
                }
            }
        }
        .bottom-wrapper {
            width: 1200px;
            min-height: 500px;
            padding-top: 24px;
            margin: 0 auto 79px;
            background: #fff;
            box-shadow: 0px 2px 4px 0px rgba(25,25,41,0.05);
            .best-area {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;
                padding: 0 24px;
                .best-list {
                    display: flex;
                    align-items: center;
                    .best-item {
                        width: 64px;
                        height: 29px;
                        text-align: center;
                        line-height: 29px;
                        color: #63656e;
                        margin-right: 8px;
                        cursor: pointer;
                        &:hover, &.active {
                            background: #e1ecff;
                            border-radius: 15px;
                            color: #3a84ff;
                        }
                    }
                }
                .label-filter {
                    display: flex;
                    align-items: center;
                    color: #3a84ff;
                    font-size: 12px;
                    cursor: pointer;
                    img {
                        height: 20px;
                        width: 20px;
                        transform: rotate(180deg);
                    }
                    &.active img {
                        transform: rotate(0);
                    }
                }
            }
            .label-area {
                margin: 0 24px 16px;
                padding: 12px 14px 2px;
                position: relative;
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #63656e;
                background: #f5f7fa;
                border-radius: 2px;
                overflow: hidden;
                .label-title {
                    align-self: start;
                    flex-shrink: 0;
                    margin: 3px 6px 0 0;
                }
                .label-list {
                    display: flex;
                    align-items: center;
                    line-height: 16px;
                    flex-wrap: wrap;
                    .label-item {
                        flex-shrink: 0;
                        padding: 3px 11px;
                        background: #fafbfd;
                        border: 1px solid rgba(151,155,165,0.30);
                        border-radius: 12px;
                        margin: 0 10px 10px 0;
                        cursor: pointer;
                        &.active, &:hover {
                        background: #e1ecff;
                        color: #3a84ff;
                        border: 1px solid #3a84ff;
                        }
                    }
                }
            }
            .topic-list {
                .data-item {
                    padding: 28px 16px 12px 24px;
                    border-bottom: 1px solid #f0f1f5;
                    &:first-child {
                        padding-top: 0px;
                    }
                    &:last-child {
                        border-bottom: none;
                    }
                    /deep/.basic-info .comment-content-wrapper {
                        width: 100% !important;
                    }
                }
            }
            .search-null, .loading {
                display: table-cell;
                vertical-align: middle;
                color: #878996;
                height: 465px;
                width: 1200px;
                text-align: center;
                background: #fff;
            }
            .search-null {
                font-size: 14px;
                p {
                    margin-top: 25px;
                }
                span {
                    color: #ff6600;
                }
            }
            .load-more {
                margin-top: 20px;
                width: 100%;
                height: 42px;
                line-height: 42px;
                color: #828282;
                font-size: 14px;
                background: #fff;
                cursor: pointer;
                outline: none;
                text-align: center;
                .no-more {
                    font-size: 12px;
                    cursor: default;
                }
            }
        }
        .go-back {
            right: 30px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// search.vue?9275f51a